<div class="c-contenedor-dialog" id="modalSegundoPlano">
  <div class="row ">
    <div class="col-12 c-contenedor-dialog__spinner">
      <div class="spinner-border text-light" role="status"></div>
    </div>
    <div class="col-12 c-contenedor-dialog__contenido">
      <h1 mat-dialog-title class="c-titulo-dialogo"> {{ data.title }} </h1>
      <mat-dialog-content class="c-titulo-subtitulo" [innerHTML]="data.description"> </mat-dialog-content>
    </div>
  </div>
</div>
